import React from 'react';
import FooterDesktop from '../../components/Footer/FooterDesktop/FooterDesktop';
import HeaderBig from '../../components/Header/Big/HeaderBig';
import BigHome from './Big/BigHome';
import styles from './Home.module.css';
import HomeMain from './HomeMain/HomeMain';
// import MiddleHome from './Middle/MiddleHome';
// import SmallHome from './Small/SmallHome';
// import HeaderMiddle from '../../components/Header/Middle/HeaderMiddle';
// import HeaderSmall from '../../components/Header/Small/HeaderSmall';

// const subImgs = [
//   { link: 'https://i.ibb.co/Y2xrHLH/3.webp', alter: 'picture' },
//   { link: 'https://i.ibb.co/VWcrbD8/1.webp', alter: 'picture' },
//   { link: 'https://i.ibb.co/P4d7V8m/2.jpg', alter: 'picture' },
//   { link: 'https://i.ibb.co/6rVPZr3/5.webp', alter: 'picture' },
//   { link: 'https://i.ibb.co/TkBDSpF/4.jpg', alter: 'picture' },
//   { link: 'https://i.ibb.co/Y2xrHLH/3.webp', alter: 'picture' },
// ];

const Home = () => {
  return (
    <div className={styles.container}>
      <HeaderBig className={styles.header} />

      <HomeMain />
      {/* <SmallHome />

      <MiddleHome /> */}
      <main className={styles.main}>
        <BigHome />
        {/* <HomeMain /> */}

        <FooterDesktop />
      </main>

      {/* <div className={styles.main}>
        <div className={styles.mainImgBox}>
          <img
            className={styles.mainImg}
            src="https://i.ibb.co/rvFdmJD/architecture-3488306-1280.jpg"
            alt="1"
            border="0"
          />
        </div>
        <div className={styles.subImgContainer}>
          {subImgs?.map((item, idx) => (
            <div className={styles.imgBox} key={idx}>
              <img
                className={styles.img}
                src={item.link}
                alt={item.alter}
                border="0"
              />
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default Home;
